<template>
  <div class="button-holder">
    <router-link :to="`/${model}/create`" class="elr-button elr-button-primary" v-if="isAuthenticated && user.role_id <= 2">Add {{singularName}}</router-link>
    <router-link :to="`/${plural(model)}/`" class="elr-button elr-button-primary">See All {{pluralName}}</router-link>
    <router-link :to="`/${model}/${item.id}/edit`" class="elr-button elr-button-primary" v-if="isAuthenticated && user.role_id <= 2">Edit {{singularName}}</router-link>
    <button :id="`button-${model}-delete`" class="elr-button elr-button-danger" @click="handleRemove" v-if="isAuthenticated && user.role_id <= 1">Delete {{singularName}}</button>
  </div>
</template>

<script>
import { capitalize, deslugify, plural, showPrompt } from '../../utils/helpers';

export default {
  name: 'ItemButtons',
  props: {
    model: {
      type: String,
      required: true
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    user: {
      type: Object,
      default: () => ({}),
    }
  },
  computed: {
    singularName() {
      return capitalize(deslugify(this.model));
    },
    pluralName() {
      return plural(this.singular);
    },
    isAuthenticated() {
      return this.user && Object.keys(this.user).length;
    }
  },
  methods: {
    handleRemove() {
      showPrompt();

      this.$emit('onRemove', {slug: this.image.slug});
    },
    plural,
  }
}
</script>

<style lang="scss" scoped>
.button-holder {
  text-align: left;
}

.elr-button {
  margin: 0 5px;
}
</style>


